export class WebAtendimentoInteracao {
    idInteracao: number;
    idDemanda: number;
    nmInteracao: string;
    icEmitente: string;
    dtEnvio: Date;
    

}